import * as Yup from 'yup';

// Regular expression for validating IPv4 address
const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

/**
 * Schema for validating IP address input
 * @param t - Translation function
 * @returns Yup schema for IP address validation
 */
const ipAddressSchema = (t: (key: string) => string) =>
  Yup.object().shape({
    ipAddress: Yup.string()
      .required(t('windscreen.errors.ip_required'))
      .matches(ipv4Regex, t('windscreen.errors.invalid_ip_format'))
  });

export default ipAddressSchema;
